import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useIntl } from 'react-intl';
import { authorizedLogout } from '../actions';
import { AUTHORIZED_MODULE } from '../../../configs/moduleNames';
import { responseLogWithNotification } from '../../../utils/utils';

export default function LogoutPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authorized = useSelector(state => state[AUTHORIZED_MODULE]);
  const { formatMessage } = useIntl();
  const { loggedIn } = authorized;
  const logoutStarted = useRef(false);

  useEffect(() => {
    if (!loggedIn) {
      navigate('/');
    } else if (!logoutStarted.current) {
      logoutStarted.current = true;
      dispatch(authorizedLogout())
        .then(() => {
          navigate('/');
        })
        .catch(response => {
          responseLogWithNotification(response, formatMessage({ id: 'app.logout' }), formatMessage({ id: 'error.default' }));
        });
    }
  }, [dispatch, formatMessage, loggedIn, navigate]);

  return null;
}
